import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';
import { Menu } from '../../menu/menu.model';
import { MenuHoverEvent } from './menu-hover-event.model';
import { SessionService } from '../../../core/session/session.service';
import { MenuService } from './menu.service';
import { Subscription } from 'rxjs';
import { FeatureToggleService } from '@app/shared/feature-toggle/feature.toggle.service';
import { Feature } from '@app/shared/feature-toggle/feature.model';
import { MenuPermissionService } from '@app/pages/users/shared/services/menu-permissions/menu-permission.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, AfterViewInit, OnDestroy {

  menu: Array<Menu> = [];
  menuiService: Array<Menu> = [];
  isShowiServices = false;
  hasLoadedMenuiService = false;
  isMenuInitialized = false;
  isMenuReady = false;
  openIdurl: string;
  menuHoverEvent: MenuHoverEvent;
  jwt: string;
  @Input() searchBarIsFocused: boolean;
  @Output() menuRetrieval: EventEmitter<Array<Menu>> = new EventEmitter<Array<Menu>>();
  @Input() intitialMenuTabIndex: number;
  private menuSubscription: Subscription;

  constructor(
    public translateService: TranslateService = null,
    private menuService: MenuService,
    private menuPermissionService: MenuPermissionService,
    private router: Router,
    private sessionService: SessionService,
    private cdRef: ChangeDetectorRef,
    private featureToggleService: FeatureToggleService,
  ) { }

  ngOnInit() {
    this.menu = [];
    this.menuiService = [];
    this.isMenuReady = false;
    this.jwt = this.sessionService.retrieveToken();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.jwt) {
        this.menuService.fetchMenu(this.translateService.currentLang, this.jwt);
      }
      this.loadMainMenu();
      this.tryLoadiServices();
    }, 0);
  }

  private loadMainMenu(): void {
    this.menuSubscription = this.menuService.getMenu().subscribe((res: Array<Menu>) => {
      this.menu = res || [];
      this.isMenuInitialized = true;
      this.isMenuReady = true;
      this.menuRetrieval.emit(this.menu);
      this.tryAddiServicesToMenu();
    });
  }

  private tryLoadiServices(): void {
    this.featureToggleService
      .fetchLoggedUserFeature(this.jwt)
      .subscribe(
        (response: Feature) => {
          if (response && response.enabled) {
            this.isShowiServices = true;
            this.loadiServicesMenu();
          } else {
            this.isShowiServices = false;
            console.log('iServices está desabilitado ou feature toggle falhou');
          }
        },
        error => {
          this.isShowiServices = false;
          console.warn('Erro no feature toggle iServices:', error);
        }
      );
  }

  private loadiServicesMenu(): void {
    if (this.hasLoadedMenuiService) {
      return;
    }

    const businessId = this.extractBusinessIdFromToken(this.jwt);
    const gestor = this.getGestorFromLocalStorage();

    this.menuPermissionService.getMenusiService(businessId, gestor).subscribe(
      response => {
        if (response) {
          this.processiServicesResponse(response);
          this.hasLoadedMenuiService = true;
          this.tryAddiServicesToMenu();
        }
      },
      error => {
        console.warn('Erro ao carregar iServices: ', error);
        this.hasLoadedMenuiService = true;
      }
    );
  }

  private processiServicesResponse(response: any): void {
    const iServiceAccess = response;
    const perfilConsultaEventosCorporativos = 'CONSULTA EVENTOS CORPORATIVOS';
    const perfilExecucaoEventosCorporativos = 'EXECUCAO EVENTOS CORPORATIVOS';
    const solucoesCustodia = 'SOLUCOES CUSTODIA';

    const iServiceMenuOption = this.createObjectMenu('iServices', 'FM6_00');
    const eventosCategory = this.createObjectCategory('FM6_04');
    const whatsappCategory = this.createObjectCategory('FM6_07');

    for (const perfil of iServiceAccess.perfis) {
      if (perfil.ativo === true) {
        if (
          perfil.nome !== perfilConsultaEventosCorporativos &&
          perfil.nome !== perfilExecucaoEventosCorporativos &&
          perfil.nome !== solucoesCustodia
        ) {
          const posicaoCategory = this.createObjectCategory('FM6_02');
          const existingCategory = iServiceMenuOption.categories.find(category => category.translationKey === 'FM6_02');

          if (!existingCategory) {
            posicaoCategory.subMenus.push(this.createObjectSubMenu('FM6_03', '/position-control'));
            iServiceMenuOption.categories.push(posicaoCategory);
          }
        } else if (perfil.nome === perfilConsultaEventosCorporativos) {
          eventosCategory.subMenus.push(this.createObjectSubMenu('FM6_05', '/corporate-events'));
        } else if (perfil.nome === perfilExecucaoEventosCorporativos) {
          eventosCategory.subMenus.push(this.createObjectSubMenu('FM6_06', '/corporate-events'));
        } else if (perfil.nome === solucoesCustodia) {
          whatsappCategory.subMenus.push(this.createObjectSubMenu('FM6_08', '/whatsapp-support'));
        }
      }
    }

    if (eventosCategory.subMenus.length > 0) {
      iServiceMenuOption.categories.push(eventosCategory);
    }

    if (whatsappCategory.subMenus.length > 0) {
      iServiceMenuOption.categories.push(whatsappCategory);
    }

    if (iServiceMenuOption.categories.length > 0) {
      this.menuiService.push(iServiceMenuOption);
    }
  }

  private tryAddiServicesToMenu(): void {
    if (this.isMenuInitialized && this.menu && this.isShowiServices && this.menuiService.length > 0) {
      const hasIServices = this.menu.find(menu => menu.name === 'iServices');
      if (!hasIServices) {
        this.menu = this.menu.concat(this.menuiService);
        this.menuRetrieval.emit(this.menu);
      }
    }
  }

  onIsHovered(event: MenuHoverEvent): void {
    this.menuHoverEvent = event;
  }

  showMenuOptions(index: number): void {
    if (!this.searchBarIsFocused) {
      this.searchBarIsFocused = false;
    }

    this.menuHoverEvent = new MenuHoverEvent(true, true, this.searchBarIsFocused, index);
  }

  hideMenuOptions(index: number): void {
    if (!this.searchBarIsFocused) {
      this.searchBarIsFocused = false;
    }

    this.menuHoverEvent = new MenuHoverEvent(false, false, this.searchBarIsFocused, index);
  }

  goHome(): void {
    this.router.navigateByUrl('/');
  }

  onShowAllOptions(event: boolean, index: number) {
    this.hideMenuOptions(index);
  }

  ngOnDestroy() {
    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }
  }

  onClickMenu(url: string, index: number) {
    this.hideMenuOptions(index);
  }

  openFullMenu(menu: any) {
    this.menuService.fullMenu(this.translateService.currentLang, menu.name.toLowerCase());
  }

  get categories() {
    return this.menu || [];
  }

  extractBusinessIdFromToken(token: string) {
    const tokenParts = token.split('.');
    const payload = JSON.parse(atob(tokenParts[1]));
    const businessId = payload.usuario;

    return businessId;
  }

  getGestorFromLocalStorage() {
    const gestor = localStorage.getItem('authUser');

    return JSON.parse(gestor)['gestor'];
  }


  showiServices() {
    this.featureToggleService
      .fetchLoggedUserFeature(this.jwt)
      .subscribe(
        (response: Feature) => {
          if (response) {
            this.isShowiServices = response.enabled;
            if (!this.hasLoadedMenuiService) {
              this.loadMenuiService();
              this.hasLoadedMenuiService = true;
            }
          }
        }
      );
  }

  loadMenuiService() {
    const businessId = this.extractBusinessIdFromToken(this.jwt);
    const gestor = this.getGestorFromLocalStorage();
    const perfilConsultaEventosCorporativos = 'CONSULTA EVENTOS CORPORATIVOS';
    const perfilExecucaoEventosCorporativos = 'EXECUCAO EVENTOS CORPORATIVOS';
    const solucoesCustodia = 'SOLUCOES CUSTODIA';

    this.menuPermissionService.getMenusiService(businessId, gestor).subscribe(
      response => {
        if (response) {
          const iServiceAccess = response;
          const iServiceMenuOption = this.createObjectMenu('iServices', 'FM6_00');
          const eventosCategory = this.createObjectCategory('FM6_04');
          const whatsappCategory = this.createObjectCategory('FM6_07');

          for (const perfil of iServiceAccess.perfis) {
            if (perfil.ativo === true) {
              if (
                perfil.nome !== perfilConsultaEventosCorporativos &&
                perfil.nome !== perfilExecucaoEventosCorporativos &&
                perfil.nome !== solucoesCustodia
              ) {
                const posicaoCategory = this.createObjectCategory('FM6_02');
                const existingCategory = iServiceMenuOption.categories.find(category => category.translationKey === 'FM6_02');

                if (!existingCategory) {
                  posicaoCategory.subMenus.push(this.createObjectSubMenu('FM6_03', '/position-control'));
                  iServiceMenuOption.categories.push(posicaoCategory);
                }
              } else if (perfil.nome === perfilConsultaEventosCorporativos) {
                eventosCategory.subMenus.push(this.createObjectSubMenu('FM6_05', '/corporate-events'));
              } else if (perfil.nome === perfilExecucaoEventosCorporativos) {
                eventosCategory.subMenus.push(this.createObjectSubMenu('FM6_06', '/corporate-events'));
              } else if (perfil.nome === solucoesCustodia) {
                whatsappCategory.subMenus.push(this.createObjectSubMenu('FM6_08', '/whatsapp-support'));
              }
            }
          }

          if (eventosCategory.subMenus.length > 0) {
            iServiceMenuOption.categories.push(eventosCategory);
          }

          if (whatsappCategory.subMenus.length > 0) {
            iServiceMenuOption.categories.push(whatsappCategory);
          }

          this.menuiService.push(iServiceMenuOption);
        }
      }
    );
  }

  private createObjectMenu(name: string, translationKey: string) {
    return {
      id: 0,
      name: name,
      description: name,
      translationKey: translationKey,
      categories: []
    };
  }

  private createObjectCategory(
    translationKeyPrincipalMenu: string,
  ) {
    return {
      translationKey: translationKeyPrincipalMenu,
      subMenus: []
    };
  }

  private createObjectSubMenu(translationKey: string, url: string) {
    return {
      translationKey: translationKey,
      tipoMenu: 6,
      url: this.featureToggleService.getiServicesLinks(url)
    };
  }

}
